import { vnTemplate } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { tagPickerEdit_template } from "./tagPickerEdit_template";
import { tagPickerView_template } from "./tagPickerView_template";
import { filterSimple_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import { filterAutocomplete_template } from "./filterAutocomplete_template";
import { filterDataset_template } from "./filterDataset_template";
import { pagination_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import { AffiliateLink } from "../../utils/types/affiliate_link";
import {
  SpecsValue,
  Tag,
  TagHyperlink,
  TagTypeOption,
} from "../../utils/types/tag";
import LocaleHandler from "../../utils/LocaleHandler";
import { TAG_DATA_FIELDS } from "../../utils/consts/tag_data_fields";
import { emaki_brand } from "../../utils/types/emaki_brand";
import { SPEC_NAME_POPUP_EDIT } from "../../utils/consts/tag_spec_type";
import { ID_TAG_TYPE } from "../../utils/consts/tag_type";
import TagDefaultsHelper from "../../utils/TagDefaultsHelper";
import { HYPERLINK_DATA_FIELDS } from "../../utils/consts/hyperlink_data_fields";
import { tagStore_template } from "./tagStore_template";
import { tagStore_helper } from "../../modules/tagStore_helper";

declare var ko: any;

export class tagPicker_template extends vnTemplate {

  protected parent: any;
  protected target: any;
  public tagEdit: tagPickerEdit_template;
  public tagView: tagPickerView_template;
  protected filterSimple: filterSimple_template;
  protected filterTagType: filterAutocomplete_template;
  protected filterDataset: filterDataset_template;
  public tagPagination: pagination_template;
  protected tagLoadEnable;
  protected tagNextpageRequested;
  protected localeHandler: LocaleHandler;
  protected idBrand: number;
  public tagStore: tagStore_template;
  public tagStoreHelper: tagStore_helper;

  protected getTemplateHtml(): string {
    return /* html */ `
            <div class="w-lightbox w-picker " data-bind="css: { 'is-visible': isShown }" >

               <div class="picker-group" data-bind="css: { 'is-activated': selectedTags().length > 0 }">
                    <div class="picker-group-in">
                        <div class="picker-group-header w-justify">
                            <div class="w-left">
                                <strong class="section-title" data-bind="text: 'Tag Group (' + selectedTags().length + ')'"></strong>
                            </div>
                            <div class="w-right">
                                <button type="button" class="btn insert-group icon i-ins" data-bind="event: { click: onClickInsertGroup },css: { 'is-disable': selectedTags().length < 2 }">Insert</button>
                            </div>
                        </div>

                        <!--

                        <div class="picker-group-header w-justify no-border">
                            <div class="w-left w-btn">
                                <button type="button" class="btn icon i-select">All Spec</button>
                                <button type="button" class="btn icon i-deselect">No Spec</button>
                            </div>
                        </div>
                        -->
                        <div class="picker-group-header w-justify">
                            <div class="w-left ">
                                <p class="form-text">
                                    Selected tags have <span data-bind="text: commonSpecs().length"></span> fields in common,
                                    <span data-bind="text: commonSpecs().filter(s => s.selected == true).length"></span> are currently selected
                                </p>
                            </div>
                            <div class="w-right">
                                <button type="button" class="btn open-popup only-icon icon i-external" data-bind="event: { click: onClickCommonSpecs }, css: { 'is-activated' : commonSpecs().length > 0 }"><span class="hidden-text">Open Common spec</span></button>
                            </div>
                        </div>

                        <div class="picker-group-header w-justify">
                            <div class="w-left ">
                                <p class="form-text">
                                    <span data-bind="text: reviewScoreCount"></span> of the <span data-bind="text: selectedTags().length"></span> selected tags have a review score; all must have a score to display any scores
                                </p>
                            </div>
                            <div class="w-right">
                                <button type="button" class="btn show-rating only-icon icon i-star-stroke" data-bind="event: { click: onClickReviewScore }, css: { 'is-enable' : selectedTags().length == reviewScoreCount(), 'is-activated' : selectedTags().length == reviewScoreCount() && isReviewScoresShown() }"><span class="hidden-text"></span></button>
                            </div>
                        </div>

                        <div class="picker-group-header w-justify">
                            <div class="w-left ">
                                <p class="form-text">
                                    Include the Community Rating for all tags.
                                </p>
                            </div>
                            <div class="w-right">
                                <button type="button"
                                    class="btn show-rating only-icon icon i-star-stroke"
                                    data-bind="
                                        event: { click: onClickGroupCommunityRating },
                                        css: {
                                            'is-enable' : true,
                                            'is-activated' : isCommunityRatingShown
                                        }
                                    "
                                >
                                   <span class="hidden-text"></span>
                                </button>
                            </div>
                        </div>

                        <div class="picker-group-body">
                            <div class="w-picker-list" data-bind="css: { 'is-with-rating' : reviewScoreCount() > 0 }">
                                <ul class="picker-list sortable" style="height: auto;" data-bind="foreach: selectedTags">

                                    <li class="picker-item icon" draggable="true" data-bind="attr: { id : id }, click: $parent.onClickViewFromGroup,  clickBubble: false ">
                                        <div class="btn reorder only-icon icon i-move i-drag"><span class="hidden-text">move</span></div>
                                        <button class="btn deselect only-icon icon i-deselect" title="select tag" type="button" data-bind="click: $parent.onClickDeleteSelectedTag, clickBubble: false " ><span class="hidden-text">deselect</span></button>

                                        <div class="icon-tag-type" data-bind="visible:  image == null, class:  type != null ?  type.name.replace(' ','-').toLowerCase() : ''" ></div>
                                        <div class="w-img" data-bind="visible:  image != null">
                                            <div class="ratio-content">
                                                <img data-bind="attr: { src:  image != null ?  image.url : ''  }">
                                            </div>
                                        </div>
                                        <div class="w-info">
                                            <strong data-bind="text:  $data.name"></strong>
                                            <span data-bind="text:  type != null ?  type.name : ''"></span>
                                            <span class="rating" data-bind="visible: (reviewScore && reviewScoreOverride == null) || reviewScoreOverride"><span data-bind="text: reviewScoreOverride ? reviewScoreOverride : reviewScore"></span>/10</span>
                                            <span class="rating community-rating"
                                                data-bind="visible: $parent.isCommunityRatingShown() && (type == null || type.id != $parent.ID_TAG_TYPE.PERSON) "
                                            >
                                                <span data-bind="text: $data.communityRating.average ?? 0"></span>/10
                                                (<span data-bind="text: $data.communityRating.count"></span> votes)
                                            </span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="lightbox-content picker">

                    <div class="picker-header  w-justify">
                        <div class="w-left">
                        </div>

                        <div class="w-center">
                            <span class="picker-header-title icon i-tag">Tag Search</span>
                        </div>

                        <!--<div class="form-body center-content" style="color:red" data-bind="visible: showPickerUploadError">ERROR OCCURRED UPLOADING FILE</div>-->
                        <div class="w-right">
                            <button type="button" class="close-btn icon i-close" data-bind="event: { click: onClickCancel }"></button>
                        </div>

                    </div>

                    <div class="picker-body">
                         <div class="list-header w-justify">
                                <div class="w-left">
                                    <button class="btn icon i-tag" type="button" data-bind="visible: permissions()['tag_edit'].write, event: { click: onClickAddTag }">Create New Tag</button>
                                </div>
                                <div class="w-center">
                                    ${this.filterSimple.getHtmlBuild()}
                                </div>
                                <div class="w-right" >
                                    <div>${this.filterDataset.getHtmlBuild()}</div>
                                </div>
                                <div class="w-right" >
                                    <div>${this.filterTagType.getHtmlBuild()}</div>
                                </div>

                         </div>

                         <div class="w-filters-selected" data-bind="visible: selectedTagTypes().length > 0">
                            <strong>Selected <br />Tag Types</strong>
                            <div class="filters-selected" data-bind="foreach: selectedTagTypes">

                                <button class="btn-f-s icon i-x-after" type="button" data-bind="text: name, event: { click: $parent.onClickDeleteSelectedTagType }"></button>
                            </div>
                         </div>

                         <div class="w-picker-list" id="tag-results-list">

                            <div class="w-msg" data-bind="css: { 'is-visible': tagResults().length == 0}">
                                <p>No Results Found</p>
                            </div>

                            <ul class="picker-list" id="tag-picker-list" data-bind="foreach: tagResults" style="height: auto;">

                                <li class="picker-item icon" data-bind="css: { 'is-selected': $data.selected && $parent.mode() != 'single-select' }">

                                    <button class="btn-zone view" title="view tag" type="button" data-bind="event: { click: $parent.onClickView }" ><span>view tag</span></button>
                                    <button class="btn-zone select" title="select tag" type="button" data-bind="visible: $parent.mode() != 'single-select', event: { click: $parent.onClickTag }" ><span>select tag</span></button>
                                    <button class="btn-zone icon i-insert-link" style="right: 6px; bottom: 6px; z-index: 69; font-size: 16px;" title="Insert Hyperlink" type="button" data-bind="visible: $parent.showHyperlink, event: { click: $parent.onClickQuickInsertHyperlink }" ><span>insert link</span></button>
                                    <div class="" data-bind="css: { 'w-img' : imageUrl != null, 'icon-tag-type' : imageUrl == null  }, class: tagType ? tagType.replace(' ','-').toLowerCase() : ''">
                                        <!-- ko if: imageUrl != null -->
                                            <div class="ratio-content">
                                                <img data-bind="attr: { src: imageUrl }">
                                            </div>
                                        <!-- /ko -->
                                    </div>
                                    <div class="w-info">
                                        <strong data-bind="text: name"></strong>
                                        <span data-bind="text:  ($data.referenceDescription ? $data.referenceDescription + ' | ' : '') + tagType + ' ' + ($data.formattedDataset ? $data.formattedDataset : '')"></span>
                                    </div>
                                </li>

                            </ul>

                         </div>
                    </div>

                    ${this.tagEdit.getHtmlBuild()}
                    ${this.tagView.getHtmlBuild()}
                </div>
            </div>

            <!-- COMMON SPEC SELECTION -->
            <div class="w-lightbox light-theme common-spec" data-bind="css: { 'is-visible': isCommonSpecsShown }">
                <div class="lightbox-content">

                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Common spec Select</h3>
                            <button type="button"  class="close-button icon i-close-2" data-bind="event: { click: onClickCancelCommonSpecs }"></button>
                        </div>
                        <div class="form-body">

                            <div class="form-group w-btn">
                                <button class="btn secondary icon i-select" type="button" data-bind="event: { click: onClickSelectAllCommonSpecs }">All Spec</button>
                                <button class="btn secondary icon i-deselect" type="button" data-bind="event: { click: onClickDeSelectAllCommonSpecs }" >No Spec</button>
                            </div>


                            <div class="form-group">
                                <hr>
                            </div>
                            <div class="form-group spec" data-bind="foreach: commonSpecs">


                               <div class="form-row">
                                    <input data-bind="checked: $data.selected, attr: { id: 'commonSpec_' + fieldId }" type="checkbox">
                                    <label class="form-label icon i-check" data-bind="text: label, attr: { for: 'commonSpec_' + fieldId }" ></label>
                               </div>

                           </div>
                        </div>



                        <div class="form-footer">
                            <button type="button" class="btn" data-bind="event: { click: onClickCancelCommonSpecs }">Cancel</button>
                            <button type="button"  class="btn highlight" data-bind="event: { click: onClickApplyCommonSpecs }">Apply</button>
                        </div>
                    </div>

                </div>
            </div>

            <div  class="w-lightbox light-theme" data-bind="css: { 'is-visible': isInsertErrorShown }">
                <div class="lightbox-content">
                    <div class="w-form lightbox-form" style="width:50rem;">
                        <div class="form-header">
                            <h3 class="form-title">Warning!</h3>
                            <button type="button" class="close-button icon i-close-2" data-bind="event: { click: onClickCloseInsertError }" ></button>
                        </div>

                        <div class="form-body">
                            <div class="form-group row" data-bind="visible: isInsertErrorForNameShown">
                                <p class="prom-text">To insert tags each must have at minimum a title.</p>
                            </div>
                            <div class="form-group row" data-bind="visible: isInsertErrorForBadgeImageShown">
                                <p class="prom-text">Badge Image: Image height must not exceed the width and image width must not exceed double the height.</p>
                            </div>
                            <div class="form-group row" data-bind="visible: isTagGroupError">
                                <p class="prom-text">Check the following tag(s):</p>
                            </div>
                            <div class="form-group row" data-bind="visible: isTagGroupError">
                                <div class="form-list bullet" data-bind="html: invalidTags"></div>
                            </div>
                         </div>

                        <div class="form-footer">
                            <button type="button" class="btn" data-bind="event: { click: onClickCloseInsertError }">Ok</button>
                        </div>
                    </div>
                </div>
             </div>


             ${this.tagStore.getHtmlBuild()}

            `;
  }

  private onLoadTemplate() {}

  protected buildViewModel(): any {
    //create observable array refresh function
    ko.observableArray.fn.refresh = function (item, index) {
      if (index == null) index = this["indexOf"](item);
      if (index >= 0) {
        this.splice(index, 1, ko.utils.extend({}, item)); // create new item
      }
    };

    // define the viewmodel data/ functions
    let huit_neuf_this = this;
    return {
      isShown: ko.observable(false),
      permissions: ko.observableArray(this.initPermissions(["tag_edit"])),
      isCommonSpecsShown: ko.observable(false),
      isTagGroupError: ko.observable(false),
      isReviewScoresShown: ko.observable(false),
      isCommunityRatingShown: ko.observable(false),
      isInsertErrorShown: ko.observable(false),
      isInsertErrorForNameShown: ko.observable(false),
      isInsertErrorForBadgeImageShown: ko.observable(false),
      reviewScoreCount: ko.observable(0),
      mode: ko.observable(""),
      target: ko.observable(""),
      invalidTags: ko.observable(""),
      newTagName: ko.observable(null),
      tagNamePlaceholder: ko.observable(""),
      newTagType: ko.observable(null),
      tagGroupElement: ko.observable(null),
      tagElement: ko.observable(null),
      groupings: ko.observableArray([]),
      tagGroupTagElements: ko.observable([]),
      tagResults: ko.observableArray([]),
      selectedTagTypes: ko.observableArray([]),
      selectedTags: ko.observableArray([]),
      commonSpecs: ko.observableArray([]),
      commonSpecsCopy: ko.observableArray([]),
      validAutoPricingPartnerNames: ko.observableArray([]),
      orderBy: ko.observable("idImage"),
      orderByDirection: ko.observable("DESC"),
      orderByAndDirection: ko.observable("idImage_DESC"),
      isSingle: ko.observable(false),
      isSelectable: ko.observable(0),
      ID_TAG_TYPE: ID_TAG_TYPE,
      datasets: ko.observableArray([]),
      showHyperlink: ko.pureComputed(() => {
        return (
          huit_neuf_this.getTemplateViewModel().mode() != "single-select" &&
          huit_neuf_this.getTemplateViewModel().selectedTags().length == 0 &&
          huit_neuf_this.caller.getModuleName() == "articles_edit_new"
        );
      }),
      onClickCancel: function (data, event) {
        huit_neuf_this.onClickCancel();
      },
      onClickAddTag: function (data, event) {
        huit_neuf_this.onClickAddTag();
      },
      onClickView: function (data, event) {
        huit_neuf_this.onClickView(data);
      },
      onClickViewFromGroup: function (data, event) {
        huit_neuf_this.onClickViewFromGroup(data);
      },
      onClickTag: function (data, event) {
        huit_neuf_this.onClickTag(data);
      },
      onClickCommonSpecs: function (data, event) {
        huit_neuf_this.onClickCommonSpecs();
      },
      onClickReviewScore: function (data, event) {
        huit_neuf_this.onClickReviewScore();
      },
      onClickDeleteSelectedTagType: function (data, event) {
        huit_neuf_this.onClickDeleteSelectedTagType(data);
      },
      onClickDeleteSelectedTag: function (data, event) {
        huit_neuf_this.onClickDeleteSelectedTag(data);
      },
      onClickCancelCommonSpecs: function (data, event) {
        huit_neuf_this.onClickCancelCommonSpecs();
      },
      onClickCloseInsertError: function (data, event) {
        huit_neuf_this.onClickCloseInsertError();
      },
      onClickApplyCommonSpecs: function (data, event) {
        huit_neuf_this.onClickApplyCommonSpecs();
      },
      onClickSelectAllCommonSpecs: function (data, event) {
        huit_neuf_this.onClickSelectAllCommonSpecs();
      },
      onClickDeSelectAllCommonSpecs: function (data, event) {
        huit_neuf_this.onClickDeSelectAllCommonSpecs();
      },
      onClickInsertGroup: function (data, event) {
        huit_neuf_this.onClickInsertGroup();
      },
      onClickQuickInsertHyperlink: function (data, event) {
        huit_neuf_this.onClickQuickInsertHyperlink(data);
      },
      onClickGroupCommunityRating: () =>
        huit_neuf_this.onClickGroupCommunityRating(),
      imageGroupSummary: (imageGroup) =>
        TagDefaultsHelper.imageGroupSummary(imageGroup),
      ...TagDefaultsHelper.viewModelProperties,
    };
  }

  protected reorderTags() {
    let selectedTags = this.getTemplateViewModel().selectedTags();
    let liElements = document.querySelectorAll(".picker-list .picker-item");

    //reorder the images based on HTML order
    let newTags: Tag[] = [];
    for (let element of liElements) {
      let idElement = element.id;
      let tag = selectedTags.find((i) => i.id === Number(element.id));
      if (tag) {
        newTags.push(tag);
      }
    }
    this.setSelectedTags(newTags);
  }

  public getIdBrand(): number | null {
    return this.idBrand;
  }

  public setValidAutoPricingPartnerNames(validAutoPricingPartnerNames) {
    this.getTemplateViewModel().validAutoPricingPartnerNames(
      validAutoPricingPartnerNames
    );
  }

  public getValidAutoPricingPartnerNames() {
    return this.getTemplateViewModel().validAutoPricingPartnerNames();
  }

  private setDragHandlers() {
    var parent = this;

    var dragSrcEl = null;

    function handleDragStart(e) {
      // Target (this) element is the source node.
      dragSrcEl = this;

      //e.dataTransfer.setData('text', 'foo');
      e.dataTransfer.effectAllowed = "move";
      e.dataTransfer.setData("text/html", this.outerHTML);

      this.classList.add("dragElem");
      return false;
    }
    function handleDragOver(e) {
      if (e.preventDefault) {
        e.preventDefault(); // Necessary. Allows us to drop.
      }

      this.style.cursor = "grab";

      let huit_neuf_this = this;
      //var dragItems = document.querySelectorAll('[draggable=true]');
      var dragItems = document.querySelectorAll(".picker-list .picker-item");
      let index = 0;
      let found = false;
      for (let item of dragItems) {
        if (dragSrcEl == item) {
          huit_neuf_this.classList.add("after");
          huit_neuf_this.classList.remove("before");
          found = true;
          break;
        }
        if (this == item) {
          huit_neuf_this.classList.add("before");
          huit_neuf_this.classList.remove("after");
          found = true;
          break;
        }
      }

      if (!found) {
        this.classList.add("before");
      }
      //this.classList.add("before");

      e.dataTransfer.dropEffect = "move"; // See the section on the DataTransfer object.

      return false;
    }

    function handleDragEnter(e) {
      // this / e.target is the current hover target.
      //this.classList.add('over');
      //this.classList.add('before');
    }

    function handleDragLeave(e) {
      this.classList.remove("before");
      this.classList.remove("after"); // this / e.target is previous target element.
    }

    function handleDrop(e) {
      // this/e.target is current target element.

      if (e.stopPropagation) {
        e.stopPropagation(); // Stops some browsers from redirecting.
      }

      if (e.preventDefault) {
        e.preventDefault(); // Necessary. Allows us to drop.
      }

      // Don't do anything if dropping the same column we're dragging.
      if (dragSrcEl != this) {
        var dropHTML = e.dataTransfer.getData("text/html");

        if (dropHTML.includes("<li")) {
          for (let child of this.parentNode.childNodes) {
            if (child == dragSrcEl) {
              this.parentNode.removeChild(dragSrcEl);
            }
          }

          if (this.classList.contains("before")) {
            this.insertAdjacentHTML("beforebegin", dropHTML);
            var dropElem = this.previousElementSibling;
          } else {
            this.insertAdjacentHTML("afterend", dropHTML);
            var dropElem = this.nextElementSibling;
          }

          addDnDHandlers(dropElem);
          //this.reorderImages();
        }
      }
      parent.reorderTags();
      this.classList.remove("before");
      this.classList.remove("after");
      return false;
    }

    function handleDragEnd(e) {
      // this/e.target is the source node.
      this.classList.remove("before");
      this.classList.remove("after");

      [].forEach.call(cols, function (col) {
        col.classList.remove("before");
        col.classList.remove("after");
      });
    }

    function addDnDHandlers(elem) {
      elem.addEventListener("dragstart", handleDragStart, false);
      elem.addEventListener("dragenter", handleDragEnter, false);
      elem.addEventListener("dragover", handleDragOver, false);
      elem.addEventListener("dragleave", handleDragLeave, false);
      elem.addEventListener("drop", handleDrop, false);
      elem.addEventListener("dragend", handleDragEnd, false);
    }

    //var dragItems = document.querySelectorAll('[draggable=true]');
    var cols = document.querySelectorAll(".picker-list .picker-item");
    [].forEach.call(cols, addDnDHandlers);
  }

  public getViewModelForRequest() {
    let selectedTagTypes: TagTypeOption[] =
      this.getTemplateViewModel().selectedTagTypes();
    let selectedTagTypeIds: number[] = [];
    for (let tagType of selectedTagTypes) {
      selectedTagTypeIds.push(tagType.id);
    }

    return {
      filters: {
        keyword: this.getTemplateViewModel().filterTagSearch.filterKeyword,
        tagTypeIds: selectedTagTypeIds,
        idDataset: this.getTemplateViewModel().filterDataset.idDataset,
        datasetTagType: this.getTemplateViewModel().filterDataset.idTagType,
        isActive: [1],
      },
      pagination: this.getTemplateViewModel().tagPagination,
      orderBy: this.getTemplateViewModel().orderBy,
      orderByDirection: this.getTemplateViewModel().orderByDirection,
    };
  }

  protected initPartial(): void {
    const appZone = this.caller.getVnAppZone();
    this.idBrand = appZone.app.params["idBrand"];

    if(!this.idBrand){
      this.idBrand = this.caller.getBrandId();
    }
    this.localeHandler = new LocaleHandler(appZone, this.idBrand);

    this.tagEdit = new tagPickerEdit_template(
      "tagPickerEdit",
      this.getTemplateViewModel(),
      this.caller
    );
    this.tagEdit.setParent(this).setLocales(this.localeHandler.locales());

    this.tagView = new tagPickerView_template(
      "tagPickerView",
      this.getTemplateViewModel(),
      this.caller
    );
    this.tagView.setParent(this).setLocales(this.localeHandler.locales());

    this.filterSimple = new filterSimple_template(
      "filterTagSearch",
      this.getTemplateViewModel(),
      this
    );

    this.filterTagType = new filterAutocomplete_template(
      "filterTagType",
      this.getTemplateViewModel(),
      this.caller
    );
    this.filterTagType.setPlaceholderAndLabel("Tag Type");
    this.filterTagType.setOptionType("Tag Type");
    this.filterTagType.setNumberOfChars(2);
    this.filterTagType.setAddNewOptionEnabled(false);
    this.filterTagType.setFilterIconCSSClass("i-tag-type-a");

    this.filterDataset = new filterDataset_template(
      "filterDataset",
      this.getTemplateViewModel(),
      this.caller
    );

    this.tagPagination = new pagination_template(
      "tagPagination",
      this.getTemplateViewModel(),
      this.caller
    );
    this.tagPagination.getTemplateViewModel().itemPerPage = 54;

    this.tagStore = new tagStore_template("tagStore", this.getTemplateViewModel(), this.caller);
    this.tagStoreHelper = new tagStore_helper(this.tagStore, this.caller.getVnAppZone(), this.caller);
    this.tagStore.setCaller(this.tagStoreHelper);
  }

  protected getTemplateName(): string {
    return "tagPicker-template";
  }

  public setMode(mode) {
    this.getTemplateViewModel().mode(mode);
    /*if(mode == "single-select"){
            this.getTemplateViewModel().selectedTab("images");
        }else{


        }*/
  }

  protected getMainElementType(): string {
    return "div";
  }

  protected getMainElementClasses(): Array<string> {
    return [];
  }

  public hideEdit() {
    this.tagEdit.hide();
  }

  public hideView() {
    this.tagView.hide();
  }

  protected tagContainsReviewScore(tag) {
    if (
      (tag.reviewScore && tag.reviewScoreOverride == null) ||
      tag.reviewScoreOverride
    ) {
      return true;
    } else {
      return false;
    }
  }

  protected onClickInsertGroup() {
    let elementToReplace = this.getTemplateViewModel().tagGroupElement();
    if (!elementToReplace) {
      elementToReplace = this.getTemplateViewModel().tagElement();
    }
    let selectedTags = this.getTemplateViewModel().selectedTags();
    let commonSpecs = this.getTemplateViewModel().commonSpecs();
    let commonSelectedSpecs = commonSpecs.filter((s) => s.selected);
    let isReviewScoresShown = this.getTemplateViewModel().isReviewScoresShown();
    let isCommunityRatingShown =
      this.getTemplateViewModel().isCommunityRatingShown();
    let isTableMode = false;
    let isAllImagesHidden = true;

    for (let st of selectedTags) {
      if (st.viewType != "hide") {
        isAllImagesHidden = false;
      }

      if (
        this.tagView.getOverrideImageToNull() &&
        st.description !== null &&
        commonSelectedSpecs.length > 1
      ) {
        isTableMode = true;
      }
    }

    if (isAllImagesHidden == false) {
      isTableMode = false;
    }

    if (this.validateTags(selectedTags, commonSelectedSpecs)) {
      let tagGroupElement = "";
      if (isTableMode) {
        tagGroupElement =
          '<div class="emaki-displayCard-group tablemode" contenteditable="false">';
      } else {
        tagGroupElement =
          '<div class="emaki-displayCard-group" contenteditable="false">';
      }

      for (let tag of selectedTags) {
        tag.includeCommunityRating = isCommunityRatingShown;
        let tagElement = this.buildTagElement(
          tag,
          commonSelectedSpecs,
          isReviewScoresShown
        );
        tagGroupElement += tagElement;
      }

      tagGroupElement += "</div>";
      if (this.target == "featuredTag") {
        let tag = { source: tagGroupElement };
        let tagInfo = {
          block: tag,
          tagObject: selectedTags,
          isVersusStyle: false,
        };
        this.caller.insertTagElement(elementToReplace, tagInfo, this.target);
      } else {
        this.caller.insertTagElement(
          elementToReplace,
          tagGroupElement,
          this.target
        );
      }
      this.tagView.hide();
      this.hide();
    }
  }

  public buildDatePickerCalendars() {
    this.tagView.linkExpirationDatePicker.buildCalendar(
      this.createEasternTimeZoneDateTime()
    );
    this.tagEdit.linkExpirationDatePicker.buildCalendar(
      this.createEasternTimeZoneDateTime()
    );

    this.tagEdit.reviewScoreEmbargoEndDate.buildCalendar();
  }

  private getFormattedEasternTimeZoneDateTime(delimiter): any {
    let date = this.createEasternTimeZoneDateTime();

    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    let hour = date.getHours();
    let minutes = date.getMinutes();

    return (
      year +
      delimiter +
      this.padInteger(month, 2) +
      delimiter +
      this.padInteger(day, 2) +
      " " +
      this.padInteger(hour, 2) +
      ":" +
      this.padInteger(minutes, 2)
    );
  }

  private padInteger(number: number, size: number) {
    let s = number + "";
    while (s.length < size) s = "0" + s;
    return s;
  }

  private createEasternTimeZoneDateTime(date?: Date): Date {
    if (!date) {
      date = new Date();
    }

    date.setMinutes(date.getMinutes() + date.getTimezoneOffset());
    //checks if DST is currently being observed, adjusts offset accordingly
    let easternTimeOffset = this.isDstObserved(date) ? -240 : -300;
    date.setMinutes(date.getMinutes() + easternTimeOffset);

    return date;
  }

  public isDstObserved(date: Date) {
    let jan = new Date(date.getFullYear(), 0, 1);
    let jul = new Date(date.getFullYear(), 6, 1);
    let stdTimezoneOffset = Math.max(
      jan.getTimezoneOffset(),
      jul.getTimezoneOffset()
    );

    return date.getTimezoneOffset() < stdTimezoneOffset;
  }

  protected validateTags(tags, selectedSpecs) {
    this.getTemplateViewModel().invalidTags("");
    this.getTemplateViewModel().isTagGroupError(false);
    //check if minimum required data is here, show error popup if not

    let isValid = true;
    let invalidTags: string[] = [];
    for (let tag of tags) {
      if (tag.badgeImage) {
        let width = tag.badgeImage.width;
        let height = tag.badgeImage.height;

        if (height > width || width > height * 2) {
          this.getTemplateViewModel().isInsertErrorShown(true);
          this.getTemplateViewModel().isInsertErrorForBadgeImageShown(true);
          invalidTags.push(tag.name);
          isValid = false;
        }
      }

      //To insert this tag you must add at minimum a title
      if (!tag.name) {
        this.getTemplateViewModel().isInsertErrorShown(true);
        this.getTemplateViewModel().isInsertErrorForNameShown(true);
        invalidTags.push(tag.name);
        isValid = false;
      }
    }

    if (tags.length > 1 && invalidTags.length > 0) {
      this.getTemplateViewModel().isTagGroupError(true);
      let invalidTagHtml = "<ul>";
      for (let tag of invalidTags) {
        invalidTagHtml += "<li>" + tag + "</li>";
      }
      invalidTagHtml += "</ul>";
      this.getTemplateViewModel().invalidTags(invalidTagHtml);
    }

    return isValid;
  }

  public setTagGroupElement(tagGroupElement) {
    this.getTemplateViewModel().tagGroupElement(tagGroupElement);
  }

  public setIsSingle(isSingle: boolean) {
    this.tagView.setIsSingle(isSingle);
  }

  public setTagElement(tagElement) {
    this.getTemplateViewModel().tagElement(tagElement);
  }

  protected loadTagGroupElement() {
    //load extra data from each tag (override data)
    let selectedTags = this.getTemplateViewModel().selectedTags();
    let tagGroupElement = this.getTemplateViewModel().tagGroupElement();

    for (let child of tagGroupElement.childNodes) {
      if (
        child.nodeName == "DIV" &&
        child.className == "emaki-displayCard tag"
      ) {
        let idTag = child.getAttribute("data-id");
        if (idTag != null) {
          let tagIndex = selectedTags.findIndex((t) => t.id == idTag);
          if (tagIndex != -1) {
            this.loadTagElement(selectedTags[tagIndex], child);
          }
        }
      }
    }
    this.setSelectedTags(selectedTags);
  }

  protected loadTagElement(tag, tagElement) {
    //check if badge exists
    let badgeElement = tagElement.querySelector(
      `[data-field="${TAG_DATA_FIELDS.BADGE}"]`
    );
    let badgeImageElement: HTMLImageElement | null = tagElement.querySelector(
      `[data-field="${TAG_DATA_FIELDS.BADGE_IMAGE}"]`
    );
    if (badgeElement) {
      tag.badge = badgeElement.innerHTML;
    }
    if (badgeImageElement) {
      tag.badgeImage = {
        url: badgeImageElement.src,
        width: badgeImageElement.width,
        height: badgeImageElement.height,
      };
    }

    //check if subtitle exists
    let subTitleElement = tagElement.querySelector(
      `[data-field="${TAG_DATA_FIELDS.SUBTITLE}"]`
    );
    if (subTitleElement) {
      tag.subtitle = subTitleElement.innerHTML;
    }

    let imageInfoElement = tagElement.querySelector(".w-img-info");
    if (imageInfoElement) {
      let showImageGroup = imageInfoElement.getAttribute("data-show-img-group");

      if (showImageGroup != null && showImageGroup != "undefined") {
        tag.showImageGroup = showImageGroup;
      }
    }

    let prosAndConsQuery = tagElement.querySelector(
      `[data-field="${TAG_DATA_FIELDS.PROSCONS}"]`
    );

    if (prosAndConsQuery) {
      let prosAndCons = prosAndConsQuery!.querySelectorAll("ul");
      let prosArray: { data: string }[] = [];
      let consArray: { data: string }[] = [];
      for (let pros of prosAndCons[0].childNodes) {
        prosArray.push({ data: pros.innerText });
      }
      for (let cons of prosAndCons[1].childNodes) {
        consArray.push({ data: cons.innerText });
      }

      tag.pros = prosArray;
      tag.cons = consArray;
    }

    // display type
    let typeElement = tagElement.querySelector(
      `[data-field="${TAG_DATA_FIELDS.DISPLAY_TYPE}"]`
    );
    if (typeElement) {
      tag.displayType = typeElement.innerHTML;
    } else {
      tag.displayType = "image";
    }

    //check if image is override
    let imageOverrideElement: HTMLImageElement | null =
      tagElement.querySelector(
        `[data-field="${TAG_DATA_FIELDS.IMAGE_OVERRIDE}"]`
      );
    let imageItem = tagElement.querySelector(
      `[data-field="${TAG_DATA_FIELDS.IMAGE}"]`
    );
    if (imageOverrideElement) {
      tag.imageOverride = {
        url: imageOverrideElement.src,
        altText: imageOverrideElement.alt,
        height: imageOverrideElement.height,
        width: imageOverrideElement.width,
      };
    } else if (imageItem == null) {
      tag.viewType = "hide";
    }

    //check if description is override
    let descriptionOverrideElement = tagElement.querySelector(
      `[data-field="${TAG_DATA_FIELDS.DESCRIPTION_OVERRIDE}"]`
    );
    if (descriptionOverrideElement) {
      tag.descriptionOverride = descriptionOverrideElement.innerHTML;
    }

    //check if title is override
    let titleOverrideElement = tagElement.querySelector(
      `[data-field="${TAG_DATA_FIELDS.TITLE_OVERRIDE}"]`
    );
    if (titleOverrideElement) {
      tag.titleOverride = titleOverrideElement.innerHTML;
    }

    //check if seo description is override
    let seoDescriptionOverrideElement = tagElement.querySelector(
      `[data-field="${TAG_DATA_FIELDS.SEO_DESCRIPTION_OVERRIDE}"]`
    );
    if (seoDescriptionOverrideElement) {
      tag.seoDescriptionOverride = seoDescriptionOverrideElement.innerHTML;
    }

    //check if review score exists
    let reviewScoreElement = tagElement.querySelector(
      `[data-field="${TAG_DATA_FIELDS.REVIEW_SCORE}"]`
    );
    if (reviewScoreElement) {
      if (reviewScoreElement.classList.contains("hidden")) {
        this.getTemplateViewModel().isReviewScoresShown(false);
      } else {
        this.getTemplateViewModel().isReviewScoresShown(true);
      }
    }

    //check if review score is override
    let reviewScoreOverrideElement = tagElement.querySelector(
      `[data-field="${TAG_DATA_FIELDS.REVIEW_SCORE_OVERRIDE}"]`
    );
    if (reviewScoreOverrideElement) {
      if (reviewScoreOverrideElement.classList.contains("hidden")) {
        this.getTemplateViewModel().isReviewScoresShown(false);
      } else {
        this.getTemplateViewModel().isReviewScoresShown(true);
      }

      tag.reviewScoreOverride = isNaN(reviewScoreOverrideElement.innerHTML)
        ? ""
        : reviewScoreOverrideElement.innerHTML;
    } else if (!reviewScoreElement && !tag.reviewScore) {
      tag.reviewScoreOverride = "";
    }

    //select the specs
    let specsElement = tagElement.querySelector(
      `[data-field="${TAG_DATA_FIELDS.SPECS}"]`
    );
    if (specsElement) {
      let specs = tag.specs;
      let fieldElements = specsElement.querySelectorAll("dt");
      let selectedSpecs: string[] = [];
      for (let fieldElement of fieldElements) {
        selectedSpecs.push(fieldElement.innerText);
      }

      if (selectedSpecs.length > 0) {
        for (let spec of specs) {
          if (selectedSpecs.indexOf(spec.label) >= 0) {
            spec.selected = true;
          }
        }
      }

      tag.specs = specs;
    }

    //select the affiliate links
    let affilateLinksElement: HTMLElement | null = tagElement.querySelector(
      `[data-field="${TAG_DATA_FIELDS.AFFILIATE_LINKS}"]`
    );
    let highestId = 0;
    let selectedLinks: string[] = [];
    if (affilateLinksElement) {
      let labelElements = affilateLinksElement.querySelectorAll("dt");
      for (let element of labelElements) {
        selectedLinks.push(element.innerText);
      }
    }
    let affiliateLinks = tag.affiliateLinks;

    if (affiliateLinks) {
      for (let link of affiliateLinks) {
        if (link.id > highestId) {
          highestId = link.id;
        }
        link.selected = selectedLinks.indexOf(link.type) >= 0;
      }
    }

    tag.affiliateLinks = affiliateLinks;

    //select the affiliate links override
    let affiliateLinksOverrideElement = tagElement.querySelector(
      `[data-field="${TAG_DATA_FIELDS.AFFILIATE_LINKS_OVERRIDE}"]`
    );
    if (affiliateLinksOverrideElement) {
      let affiliateLinks = tag.affiliateLinks;
      let tempAffiliateLinks = tag.tempAffiliateLinks;
      let labelElements = affiliateLinksOverrideElement.querySelectorAll("dt");
      let valueElements = affiliateLinksOverrideElement.querySelectorAll("dd");
      let allTempLinks: AffiliateLink[] = [];

      for (let element of labelElements) {
        allTempLinks.push({ type: element.innerText, selected: true });
      }

      let index = 0;
      for (let element of valueElements) {
        if (allTempLinks[index]) {
          allTempLinks[index].value = element.childNodes[0].href;
          allTempLinks[index].price = element.getAttribute("data-price");
          allTempLinks[index].salePrice =
            element.getAttribute("data-sale-price");
          allTempLinks[index].automaticPricing = this.getBooleanAttribute(
            element,
            "data-price-auto"
          );
          allTempLinks[index].automaticPricingAvailable =
            this.getBooleanAttribute(element, "data-auto-available");
          allTempLinks[index].linkTextOverride =
            element.getAttribute("data-text-override");
          allTempLinks[index].dateExpiration = element.getAttribute(
            "data-expiration-date"
          );
          index += 1;
        }
      }

      //add any temp links that are not part of the tag
      for (let link of allTempLinks) {
        link.id = highestId + 1;
        highestId += 1;
        link.isNew = true;
        tempAffiliateLinks.push(link);
      }

      tag.tempAffiliateLinks = tempAffiliateLinks;
    }

    let tagVideoElement = tagElement.querySelector(
      `[data-field="${TAG_DATA_FIELDS.TAG_VIDEO}"]`
    );
    tag.includeTagVideo = !!tagVideoElement;

    tag.includeStreamRentBuyLinks = tagElement
      ? tagElement.getAttribute("data-show-streamrentbuy-links") === "true"
      : false;
    tag.includeCommunityRating = tagElement
      ? tagElement.getAttribute("data-include-community-rating") === "true"
      : false;
  }

  protected insertTag(elementToReplace, tagObject) {
    let selectedSpecs = tagObject.specs.filter((s) => s.selected == true);

    if (this.validateTags([tagObject], selectedSpecs)) {
      let newTagElement = this.buildTagElement(tagObject);
      if (this.target == "featuredTag") {
        let tag = { source: newTagElement };
        let tagInfo = {
          block: tag,
          tagObject: [tagObject],
          isVersusStyle: false,
        };
        this.caller.insertTagElement(elementToReplace, tagInfo, this.target);
      } else {
        this.caller.insertTagElement(
          elementToReplace,
          newTagElement,
          this.target,
          tagObject
        );
      }
      this.tagView.hide();
      this.hide();
    }
  }

  /**
   * This process is the basis for how the tag import tool will build out the tag element as well.
   * Please use this as a reference if adding any functionality to the importer.
   */
  protected buildTagElement(
    tagObject: Tag,
    specsToSelect = null,
    showReviewScore = true
  ) {
    let id = tagObject.id;
    let name = tagObject.name;
    let subtitle = tagObject.subtitle;
    let badge = tagObject.badge;
    let badgeImage = tagObject.badgeImage;
    let description = tagObject.description;
    let descriptionOverride = tagObject.descriptionOverride;
    let seoDescription = tagObject.seoDescription;
    let seoDescriptionOverride = tagObject.seoDescriptionOverride;
    let reviewScore = tagObject.reviewScore;
    let reviewScoreOverride = tagObject.reviewScoreOverride;
    let image = tagObject.image;
    let iconImage = tagObject.iconImage;
    let imageOverride = tagObject.imageOverride;
    let showImageGroup = tagObject.showImageGroup;
    let specs = tagObject.specs || [];
    let selectedSpecs = specs.filter((s) => s.selected == true);
    let affiliateLinks = tagObject.affiliateLinks || [];
    let tempAffiliateLinks = tagObject.tempAffiliateLinks || [];
    let pros = tagObject.pros || [];
    let cons = tagObject.cons || [];
    let includeCommunityRating =
      tagObject.includeCommunityRating &&
      (tagObject.type == null ||
        (typeof tagObject.type != "string" &&
          tagObject.type.id != ID_TAG_TYPE.PERSON));
    let communityRating = tagObject.communityRating;
    let includeStreamRentBuyLinks = tagObject.includeStreamRentBuyLinks;
    let selectedAffiliateLinks = affiliateLinks.filter(
      (s) => s.selected == true
    );
    let selectedTempAffiliateLinks = tempAffiliateLinks.filter(
      (s) => s.selected == true
    );
    let badgeElement = "";
    let badgeImageElement = "";
    let hideImage = tagObject.hideImage;
    let displayType = tagObject.displayType;
    let viewType = tagObject.viewType;
    let vignette = tagObject.details ? tagObject.details.vignette : null;
    let idVignette = "";
    let vignetteName = "";
    let titleOverride = tagObject.titleOverride;
    let tagVideo = tagObject.details ? tagObject.details.video : null;

    if (tagObject.defaults && tagObject.defaults.vignette) {
      idVignette = tagObject.defaults.vignette.id;
      vignetteName = tagObject.defaults.vignette.name;
    }
    if (vignette) {
      idVignette = vignette.id;
      vignetteName = vignette.name;
    }

    //viewType
    let viewTypeElement = `<div data-field="${TAG_DATA_FIELDS.VIEW_TYPE}" style="display: none">${viewType}</div>`;
    let displayTypeElement = `<div data-field="${TAG_DATA_FIELDS.DISPLAY_TYPE}" style="display: none">${displayType}</div>`;

    if (badge != null) {
      if (badge == "Custom Badge") {
        badgeElement = `<span class="badge" data-field="${TAG_DATA_FIELDS.BADGE}"></span>`;
      } else {
        badgeElement = `<span class="badge" data-field="${TAG_DATA_FIELDS.BADGE}">${badge}</span>`;
      }
    }
    if (badgeImage != null) {
      badgeImageElement = `<img data-field="${TAG_DATA_FIELDS.BADGE_IMAGE}" src="${badgeImage.url}">`;
    }

    let titleElement: string = "";

    if (titleOverride != null) {
      titleElement = `<h3 data-field="${TAG_DATA_FIELDS.TITLE_OVERRIDE}">${titleOverride}</h3>`;
    } else {
      titleElement = `<h3 data-field="${TAG_DATA_FIELDS.TITLE}">${name}</h3>`;
    }

    let subtitleElement = "";
    if (subtitle != null) {
      subtitleElement = `<span class="heading-desc" data-field="${TAG_DATA_FIELDS.SUBTITLE}">${subtitle}</span>`;
    }

    //reviewScore
    let reviewScoreElement = "";
    let hiddenClass = "";

    const embargoScoreIsIncluded = tagObject.embargoScoreIsIncluded
    let embargoScoreIsIncludedElement="";
    if(embargoScoreIsIncluded) {
       embargoScoreIsIncludedElement = `<div style="display: none;" data-field="${TAG_DATA_FIELDS.EMBARGO_SCORE_IS_INCLUDED}">1</div>`
    }

    if (!showReviewScore) {
      hiddenClass = ' class="hidden" ';
    }

    if (reviewScore != null) {
      reviewScoreElement =
        `<div class="w-rating"><strong>Rating</strong><div${hiddenClass}><span${hiddenClass} data-field="${TAG_DATA_FIELDS.REVIEW_SCORE}">${reviewScore}</span> out of 10</div></div>`;
    }

    if (reviewScoreOverride != null) {
      if (reviewScoreOverride != "") {
        reviewScoreElement =
          '<div class="w-rating"><strong>Rating</strong><div' +
          hiddenClass +
          "><span" +
          hiddenClass +
          ' data-field="' +
          TAG_DATA_FIELDS.REVIEW_SCORE_OVERRIDE +
          '">' +
          reviewScoreOverride +
          "</span> out of 10</div></div>";
      } else {
        reviewScoreElement = `<div data-field="${TAG_DATA_FIELDS.REVIEW_SCORE_OVERRIDE}"></div>`;
      }
    }

    if(tagObject.details.reviewScoreIsUnderEmbargo){
      if(!tagObject.embargoScoreIsIncluded){
        reviewScoreElement = `<div data-field="${TAG_DATA_FIELDS.REVIEW_SCORE_OVERRIDE}"></div>`;
      }else{
        reviewScoreElement = `<div class="w-rating"><strong>Rating</strong><div><span data-field="${TAG_DATA_FIELDS.REVIEW_SCORE}">rating:source</span></div></div>`;
      }
    }

    let communityRatingElement = "";
    if (includeCommunityRating) {
      communityRatingElement =
        '<div class="w-community-rating"><strong>Community Rating</strong><div><span data-field="' +
        TAG_DATA_FIELDS.COMMUNITY_RATING +
        '">' +
        (communityRating.average ? communityRating.average : 0) +
        "</span> out of 10 (" +
        communityRating.count +
        " reviews)</div></div>";
    }

    //description
    let descriptionElement = "";
    if (description != null) {
      descriptionElement = `<div data-field="${TAG_DATA_FIELDS.DESCRIPTION}">${description}</div>`;
    }
    if (descriptionOverride != null) {
      descriptionElement = `<div data-field="${TAG_DATA_FIELDS.DESCRIPTION_OVERRIDE}">${descriptionOverride}</div>`;
    }

    //seoDescription
    let seoDescriptionElement = "";
    if (seoDescription != null) {
      seoDescriptionElement = `<div data-field="${TAG_DATA_FIELDS.SEO_DESCRIPTION}">${seoDescription}</div>`;
    }
    if (seoDescriptionOverride != null) {
      seoDescriptionElement = `<div data-field="${TAG_DATA_FIELDS.SEO_DESCRIPTION_OVERRIDE}">${seoDescriptionOverride}</div>`;
    }

    //image
    let imageElement = "";
    if (displayType == "vignette") {
      imageElement = `<div>Vignette: ${vignetteName}</div><div class="w-img"><img style="width: 100px" src="/assets/images/vignette-placeholder.png" alt="vignette" /></div>`;
    } else {
      if (
        image != null &&
        !tagObject.overrideImageToNull &&
        viewType != "hide"
      ) {
        imageElement = `<div class="w-img"><img data-image-id="${image["id"]}" data-field="${TAG_DATA_FIELDS.IMAGE}" src="${image["url"]}" alt="${image["altText"]}" width="${image["width"]}" height="${image["height"]}" /></div>`;
      }
      if (
        imageOverride != null &&
        !tagObject.overrideImageToNull &&
        viewType != "hide"
      ) {
        imageElement = `<img data-image-id="${image["id"]}" data-field="${TAG_DATA_FIELDS.IMAGE_OVERRIDE}" src="${imageOverride["url"]}" alt="${imageOverride["altText"]}" width="${imageOverride["width"]}" height="${imageOverride["height"]}" />`;
      }
    }

    //iconImage
    let iconImageElement = "";
    if (iconImage != null) {
      iconImageElement =
        '<div class="w-iconimg"><img data-image-id="' +
        iconImage["id"] +
        '" data-field="iconImage" src="' +
        iconImage["url"] +
        '" alt="' +
        iconImage["altText"] +
        '" width="' +
        iconImage["width"] +
        '" height="' +
        iconImage["height"] +
        '" /></div>';
    }

    //tag video
    let tagVideoElement = "";
    if (tagVideo != null) {
      tagVideoElement = `<div data-field="${TAG_DATA_FIELDS.TAG_VIDEO}" id="${tagVideo.id}" url="${tagVideo.url}">${tagVideo.title}<img data-field="${TAG_DATA_FIELDS.TAG_VIDEO_THUMBNAIL}" src="${tagVideo.thumbnail.url}" alt="${tagVideo.title}"></div>`;
    }

    //specs
    let specsElement = "";

    if (specsToSelect != null) {
      for (let selectedSpec of specsToSelect) {
        let spec = specs.find((s) => s.fieldId == selectedSpec.fieldId);
          if (spec.dataType == "images") continue;
        if (
          spec.isDefault &&
          spec.defaultValue != null &&
          spec.defaultValue.length > 0
        ) {
          //create each list item
          specsElement +=
            '<dt data-spec-type="' +
            spec.dataType +
            '" data-spec-id="' +
            spec.fieldId +
            '">' +
            spec.label +
            "</dt><dd>" +
            spec.defaultValue +
            "</dd>";
        } else if (spec.value != null && spec.value.length > 0) {
          //create each list item
          specsElement +=
            '<dt data-spec-type="' +
            spec.dataType +
            '" data-spec-id="' +
            spec.fieldId +
            '">' +
            spec.label +
            "</dt><dd>" +
            spec.value +
            "</dd>";
        }
      }
    } else {
      for (let spec of selectedSpecs) {

         if (spec.dataType == "images") continue;

        if (
          spec.isDefault &&
          spec.defaultValue != null &&
          spec.defaultValue.length > 0
        ) {
          //create each list item
          if (
            spec.dataType == "rating" &&
            spec.ratingScale != null &&
            spec.ratingScale != ""
          ) {
            spec.defaultValue = spec.defaultValue + "/" + spec.ratingScale;
          }

          if (spec.dataType == "images" && Array.isArray(spec.defaultValue)) {
              spec.defaultValue = spec.defaultValue.length + " images in group";
          }
          specsElement +=
            '<dt data-spec-type="' +
            spec.dataType +
            '" data-spec-id="' +
            spec.fieldId +
            '">' +
            spec.label +
            "</dt><dd>" +
            spec.defaultValue +
            "</dd>";
        } else if (spec.value != null && spec.value.length > 0) {
          //create each list item
          if (
            spec.dataType == "rating" &&
            spec.ratingScale != null &&
            spec.ratingScale != ""
          ) {
            spec.value = spec.value + "/" + spec.ratingScale;
          }
          if (spec.dataType == "images" && Array.isArray(spec.value)) {
              spec.value = spec.value.length + " images in group";
          }
          specsElement +=
            '<dt data-spec-type="' +
            spec.dataType +
            '" data-spec-id="' +
            spec.fieldId +
            '">' +
            spec.label +
            "</dt><dd>" +
            spec.value +
            "</dd>";
        }
      }
    }

    if (specsElement != "") {
      specsElement = `<strong>Specifications</strong><dl data-field="${TAG_DATA_FIELDS.SPECS}">${specsElement}</dl>`;
    }

    const formatAffiliateLink = (link: AffiliateLink) =>
      `<dt>${link.type}</dt>` +
      `<dd data-store="${link.store}"` +
      (link.automaticPricing !== null &&
        ` data-price-auto="${link.automaticPricing}" `) +
      (link.automaticPricingAvailable !== null &&
        ` data-auto-available="${link.automaticPricingAvailable}" `) +
      (link.price !== null && ` data-price="${link.price}" `) +
      (link.salePrice !== null && ` data-sale-price="${link.salePrice}" `) +
      (link.linkTextOverride !== null &&
        ` data-text-override="${
          link.linkTextOverride ? link.linkTextOverride : ""
        }" `) +
      (link.dateExpiration !== null &&
        ` data-expiration-date="${link.dateExpiration}" `) +
      (link.countryCode !== null &&
        ` data-country-code="${link.countryCode}" `) +
      `><a href="${link.value}" target="_blank">${this.getButtonText(
        link
      )}</a></dd>`;

    //affiliate links
    let affiliateLinksElement = selectedAffiliateLinks
      .map(formatAffiliateLink)
      .join("");

    //pros and cons
    let prosHtml = "";
    if (pros !== null) {
      prosHtml += `<div data-field="${TAG_DATA_FIELDS.PROSCONS}" class="proscons"></br><ul class="${TAG_DATA_FIELDS.PROS}">`;
      for (let p of pros) {
        prosHtml += "<li>" + p.data + "</li>";
      }
      prosHtml += "</ul>";
    }
    if (cons !== null) {
      prosHtml += `<ul class="${TAG_DATA_FIELDS.CONS}">`;
      for (let c of cons) {
        prosHtml += "<li>" + c.data + "</li>";
      }
      prosHtml += "</ul></div>";
    }

    //temp affiliate links
    let tempAffiliateLinksElement = selectedTempAffiliateLinks
      .map(formatAffiliateLink)
      .join("");

    if (affiliateLinksElement != "") {
      affiliateLinksElement = `<strong>Affiliate Links</strong><dl data-field="${TAG_DATA_FIELDS.AFFILIATE_LINKS}">${affiliateLinksElement}</dl>`;
    }

    if (tempAffiliateLinksElement != "") {
      tempAffiliateLinksElement = `<strong>Affiliate Links Override</strong><dl data-field="${TAG_DATA_FIELDS.AFFILIATE_LINKS_OVERRIDE}">${tempAffiliateLinksElement}</dl>`;
    }

      let optionNames = [];
      for (let sl in affiliateLinks) {
        if (affiliateLinks[sl].option && affiliateLinks[sl].option != "" && optionNames.filter(name => name.name.toLowerCase() === affiliateLinks[sl].option.toLowerCase()).length == 0) {
          optionNames.push({name: affiliateLinks[sl].option, count: 1});
        } else if (affiliateLinks[sl].option && affiliateLinks[sl].option != "" && optionNames.filter(name => name.name.toLowerCase() === affiliateLinks[sl].option.toLowerCase()).length >= 0) {
          optionNames.filter(name => name.name.toLowerCase() === affiliateLinks[sl].option.toLowerCase())[0].count++;
        }
      }

      let optionString = "";

      if (optionNames.length > 0) {

        optionString = "Contains ";

        for (let on in optionNames) {
          optionString += "<span style=\"padding-bottom: 0;transform: none;\">" + optionNames[on].count + " " + optionNames[on].name + " / </span>";
        }

        optionString = optionString.slice(0, optionString.length - 9) + "</span> Option Links";
      }

    const showStreamRentBuyLinks = includeStreamRentBuyLinks ? "true" : "false";
    const streamRentBuyElement = includeStreamRentBuyLinks && optionString
      ? "<em" + optionString + "</em>"
      : "";
    const includeCommunityRatingValue = includeCommunityRating
      ? "true"
      : "false";

    //build the full tag
    let tagElement =
      `<div class="emaki-displayCard tag" contenteditable="false" data-show-streamrentbuy-links="${showStreamRentBuyLinks}" data-include-community-rating="${includeCommunityRatingValue}" data-id="${id}">` +
      '<div class="heading">' +
      displayTypeElement +
      viewTypeElement +
      badgeElement +
      badgeImageElement +
      titleElement +
      subtitleElement +
      reviewScoreElement +
      communityRatingElement +
      '</div><div class="w-img-info" data-show-img-group="' +
      showImageGroup +
      '">' +
      imageElement +
      iconImageElement +
      '<div class="w-info">' +
      descriptionElement +
      seoDescriptionElement +
      specsElement +
      prosHtml +
      affiliateLinksElement +
      tempAffiliateLinksElement +
      streamRentBuyElement +
      tagVideoElement +
      embargoScoreIsIncludedElement +
      "</div></div></div>";
    // do not remove that space next to div
    return tagElement;
  }

  protected insertTagHyperlink(
    elementToReplace,
    tagHyperlinkObject,
    quickInsert: boolean = false
  ) {
    let tagObject = tagHyperlinkObject.tag;
    if (this.validateTags([tagObject], [])) {
      let newTagElement = this.buildTagHyperlinkElement(
        tagHyperlinkObject,
        quickInsert
      );
      this.caller.insertTagHyperlinkElement(
        elementToReplace,
        newTagElement,
        this.target
      );
      this.tagView.hide();
      this.hide();
    }
  }

  protected buildTagHyperlinkElement(
    tagHyperlinkObject: TagHyperlink,
    quickInsert: boolean = false
  ) {
    let tag = tagHyperlinkObject.tag;
    let id = tag.id;
    let isTitleOverride = tagHyperlinkObject.isTitleOverride;
    let title = isTitleOverride ? tagHyperlinkObject.titleOverride : tag.name;
    if (title === "") {
      title = "&nbsp;";
    }

    let showHyperlinkIcon = tagHyperlinkObject.showHyperlinkIcon;

    let isIconOverride = tagHyperlinkObject.isIconOverride;
    let iconOverride = tagHyperlinkObject.iconOverride;

    let iconImageUrl = "";

    if (quickInsert) {
      tagHyperlinkObject.isVignette = true;
      // if this is the brand owner, hyperlink can only be set to internal
      tagHyperlinkObject.isBrandOwnerUrlHubPage =
        this.getIdBrand() != tag.idBrandOwner;
      showHyperlinkIcon = true;
    }

    if (showHyperlinkIcon) {
      if (isIconOverride) {
        iconImageUrl = iconOverride.url;
      } else {
        iconImageUrl = tag.iconImage ? tag.iconImage.url : null;
        if (!iconImageUrl) {
          iconImageUrl = tag.iconImage ? tag.iconImage.url : null;
        }
      }
    }

    let isTagColorOverride = tagHyperlinkObject.isTagColorOverride;
    let color = null;
    if (isTagColorOverride) {
      color = tagHyperlinkObject.colorOverride;
    } else {
      color = tag.details && tag.details.color ? tag.details.color : null;
      if (!color) {
        color = tag.defaults && tag.defaults.color ? tag.defaults.color : null;
      }
    }

    let idVignette = null;
    if (tag.details) {
      idVignette = tag.details.vignette ? tag.details.vignette.id : null;
      if (idVignette == null && tag.defaults && tag.defaults.vignette) {
        idVignette = tag.defaults.vignette.id;
      }
    }

    let isVignette = tagHyperlinkObject.isVignette && !!idVignette;

    let permalink = tagHyperlinkObject.permalink;
    // true by default
    let isBrandOwnerUrlHubPage =
      typeof tagHyperlinkObject.isBrandOwnerUrlHubPage !== "undefined" &&
      tagHyperlinkObject.isBrandOwnerUrlHubPage !== null
        ? tagHyperlinkObject.isBrandOwnerUrlHubPage
        : false;

    let idProp = !!id ? `${HYPERLINK_DATA_FIELDS.ID}="${id}"` : "";
    let isTitleOverrideProp = !!isTitleOverride
      ? `${HYPERLINK_DATA_FIELDS.IS_TITLE_OVERRIDE}="true"`
      : "";
    let colorProp = !!color ? `${HYPERLINK_DATA_FIELDS.COLOR}="${color}"` : "";
    let colorOverrideProp = !!isTagColorOverride
      ? `${HYPERLINK_DATA_FIELDS.IS_COLOR_OVERRIDE}="true"`
      : "";
    let iconProp = `${HYPERLINK_DATA_FIELDS.ICON}="${
      iconImageUrl != null && iconImageUrl != ""
    }"`;
    let iconOverrideProp =
      isIconOverride && iconOverride
        ? `${HYPERLINK_DATA_FIELDS.ICON_OVERRIDE_ID}="${iconOverride.id}"`
        : "";
    let isVignetteProp = `${HYPERLINK_DATA_FIELDS.IS_VIGNETTE}="${isVignette}"`;
    let permalinkProp = !!permalink
      ? `${HYPERLINK_DATA_FIELDS.PERMALINK}="${permalink}"`
      : "";
    // makes more sense to negate the current state, rather than have to backfill all the content.
    let isBrandOwnerUrlHubPageProp = isBrandOwnerUrlHubPage
      ? `${HYPERLINK_DATA_FIELDS.IS_BRANDOWNER_HUBPAGE}="true"`
      : "";
    let quickInsertProp = quickInsert
      ? `${HYPERLINK_DATA_FIELDS.QUICK_INSERT}="true"`
      : "";
    let showHyperlinkIconProp = !!showHyperlinkIcon
      ? `${HYPERLINK_DATA_FIELDS.ICON}="true"`
      : "";

    let hyperlinkPropArray = [
      idProp,
      isTitleOverrideProp,
      showHyperlinkIconProp,
      iconOverrideProp,
      iconProp,
      colorOverrideProp,
      colorProp,
      isVignetteProp,
      permalinkProp,
      isBrandOwnerUrlHubPageProp,
      quickInsertProp,
    ];

    let hyperlinkProps = hyperlinkPropArray.filter((s) => s != "").join(" ");
    let style = iconImageUrl
      ? `style="background-image: url('${iconImageUrl}');"`
      : "";

    return `<span class="emaki-displayCard hyperlink" contenteditable="false" ${style} ${hyperlinkProps}>${title}</span>`;
  }

  protected getButtonText(link: AffiliateLink) {
    let buttonText = "See at " + link.type;

    if (link.linkTextOverride) {
      buttonText = link.linkTextOverride;
    } else {
      let expired = false;
      if (link.dateExpiration != null) {
        //check if expiry date has passed
        let currentDate = this.createEasternTimeZoneDateTime();
        let dateExpiration = new Date(link.dateExpiration);

        //expired
        if (dateExpiration < currentDate) {
          expired = true;
        }
      }

      if (link.price != null) {
        buttonText = "$" + link.price + " at " + link.type;
      }

      if (
        link.salePrice != null &&
        (!expired || (expired && link.price == null))
      ) {
        buttonText = "$" + link.salePrice + " at " + link.type;
      }
    }

    return buttonText;
  }

  protected onClickViewFromGroup(data) {
    this.tagView.setTagElement(null);
    this.tagView.setTag(data, true);
    this.tagView.setIsPartOfGroup(true);
    this.tagView.setGroupExists(true);
    this.tagView.show();
  }
  public getOnlickView(data) {
    this.onClickView(data);
  }
  protected onClickView(data) {
    if (this.getTemplateViewModel().selectedTags().length > 0) {
      this.onClickTag(data);
    } else {
      this.tagView.setIsPartOfGroup(false);
      if(this.caller.getModuleName() != "listing_page_edit" && this.caller.getModuleName() !="sensai_vault") {
        this.tagView.setPresetSelectStep(true);
      }
      this.caller.getTag(data.id);
      this.tagView.show();
    }
  }

  public updateSelectedTag(tag) {
    let selectedTags = this.getTemplateViewModel().selectedTags();
    let tagIndex = selectedTags.findIndex((t) => t.id == tag.id);
    if (tagIndex != -1) {
      selectedTags[tagIndex] = tag;
      this.setSelectedTags(selectedTags);
      //this.getTemplateViewModel().selectedTags([]);
      //this.getTemplateViewModel().selectedTags(selectedTags);
    }
  }

  public updateSelectedTagAfterSave(tag: Tag) {
    let updatedTag = this.initTag(tag);

    let selectedTags = this.getTemplateViewModel().selectedTags();
    let selectedTag = selectedTags.find((t) => t.id == tag.id);
    if (selectedTag != null) {
      //preserve selections
      for (let spec of updatedTag.specs) {
        if (
          selectedTag.specs.findIndex(
            (s) => s.fieldId == spec.fieldId && s.selected == true
          ) != -1
        ) {
          spec.selected = true;
        }
      }
      for (let link of updatedTag.affiliateLinks) {
        if (
          selectedTag.affiliateLinks.findIndex(
            (l) => l.id == link.id && l.selected == true
          ) != -1
        ) {
          link.selected = true;
        }
      }
      if (updatedTag.specsValues != null || updatedTag.specDefaults != null) {
        updatedTag.allSpecs = this.foldDefaultsIntoSpecs(updatedTag);
      }

      //selectedTags[tagIndex] = tag;
      selectedTag.name = updatedTag.name;
      selectedTag.description = updatedTag.description;
      selectedTag.image = updatedTag.image;
      selectedTag.details.color = updatedTag.details.color;
      selectedTag.seoDescription = updatedTag.seoDescription;
      selectedTag.affiliateLinks = updatedTag.affiliateLinks;
      selectedTag.specs = updatedTag.specs;
      selectedTag.allSpecs = updatedTag.allSpecs;
      selectedTag.includeStreamRentBuyLinks =
        updatedTag.includeStreamRentBuyLinks;
      selectedTag.includeCommunityRating = updatedTag.includeCommunityRating;
      selectedTag.communityRating = updatedTag.communityRating;
      this.setSelectedTags(selectedTags);
    }
  }


  protected onClickAddTag() {

    this.tagStore.openTagStore();
  }

  protected onClickReviewScore() {
    let isReviewScoresShown = this.getTemplateViewModel().isReviewScoresShown();
    this.getTemplateViewModel().isReviewScoresShown(!isReviewScoresShown);
  }

  protected onClickGroupCommunityRating() {
    const isCommunityRatingShown =
      !this.getTemplateViewModel().isCommunityRatingShown();
    this.getTemplateViewModel().isCommunityRatingShown(isCommunityRatingShown);
  }

  protected onClickCommonSpecs() {
    //create a copy to undo changes on cancel
    let commonSpecs = this.getTemplateViewModel().commonSpecs();

    let commonSpecsCopy = JSON.parse(JSON.stringify(commonSpecs));
    this.getTemplateViewModel().commonSpecsCopy(commonSpecsCopy);

    this.getTemplateViewModel().isCommonSpecsShown(true);
  }

  protected onClickTag(tag) {
    if (!tag.selected) {
      this.caller.getTag(tag.id, true);
    } else {
      this.deselectTag(tag);
    }

    tag.selected = !tag.selected;

    this.refreshTagResults();
  }

  protected refreshTagResults() {
    let tagResults = this.getTemplateViewModel().tagResults();
    let selectedTags = this.getTemplateViewModel().selectedTags();

    let previouslySelectedTags = tagResults.filter((s) => s.selected == true);
    for (let tag of previouslySelectedTags) {
      tag.selected = false;
    }

    for (let tag of selectedTags) {
      let foundTag = tagResults.find((t) => t.id == tag.id);
      if (foundTag) {
        foundTag.selected = true;
      }
    }
    this.getTemplateViewModel().tagResults([]);
    this.getTemplateViewModel().tagResults(tagResults);
  }

  public selectTags(tags) {
    for (let tag of tags) {
      this.selectTag(tag);
    }
    this.loadTagGroupElement();
  }

  public setSelectedTags(selectedTags) {
    this.getCommonSpecs(selectedTags);
    this.selectAllCommonSpecs(selectedTags);
    this.getTemplateViewModel().selectedTags([]);
    this.getTemplateViewModel().selectedTags(selectedTags);
    this.setDragHandlers();
    this.refreshTagResults();
  }

  public getCommonSpecs(selectedTags) {
    let commonSpecs = [];

    //create deep copy of tags array
    let tags = JSON.parse(JSON.stringify(selectedTags));
    let tagFields = [];
    let selectedTagFields = [];
    let reviewScoreCount = 0;
    let isCommunityRatingShown = false;

    //get all fields with values for each tag
    for (let tag of tags) {
      //get tags with review scores
      if (this.tagContainsReviewScore(tag)) {
        reviewScoreCount += 1;
      }

      if (tag.includeCommunityRating) {
        isCommunityRatingShown = true;
      }

      let specsWithValues = tag.specs.filter(
        (s) =>
          (s.value != null && s.value != "") ||
          (s.isDefault && s.defaultValue != null && s.defaultValue != "")
      );
      let selectedSpecs = specsWithValues.filter((s) => s.selected);

      tagFields[tag.id] = specsWithValues.map((a) => a.fieldId);
      selectedTagFields[tag.id] = selectedSpecs.map((a) => a.fieldId);
    }

    this.getTemplateViewModel().isCommunityRatingShown(isCommunityRatingShown);

    //get the fields in common
    if (tagFields.length > 0) {
      let commonFields = tagFields.reduce((a, b) =>
        a.filter((c) => b.includes(c))
      );
      let commonSelectedFields = selectedTagFields.reduce((a, b) =>
        a.filter((c) => b.includes(c))
      );

      if (commonFields.length > 0) {
        commonSpecs = tags[0].specs.filter(
          (s) => commonFields.indexOf(s.fieldId) !== -1
        );
      }

      //select specs that are in common and selected
      for (let spec of commonSpecs) {
        let index = commonSelectedFields.findIndex((f) => f == spec.fieldId);
        if (index != -1) {
          spec.selected = true;
        } else {
          spec.selected = false;
        }
      }
    }

    this.getTemplateViewModel().reviewScoreCount(reviewScoreCount);
    this.getTemplateViewModel().commonSpecs(commonSpecs);
  }

  protected onClickCancel() {
    //this.deselectAllTags();
    this.tagView.setTagElement(null);
    this.hide();
  }

  protected filterSimpleCancel() {
    this.caller.filterSimpleCancel();
  }

  protected filterSimpleOnChange(idElement) {
    this.resetPagination();
    this.caller.filterSimpleOnChange(idElement);
  }

  public resetPagination() {
    this.getTemplateViewModel().tagPagination.pageNumber(1);
    this.getTemplateViewModel().tagResults([]);
    this.tagLoadEnable = null;
  }

  public setSimpleFilterKeyword(filterKeyword) {
    this.filterSimple.setFilterKeyword(filterKeyword);
  }

  public setParent(parent) {
    this.parent = parent;
  }

  public setTarget(target) {
    this.target = target;
  }

  public getTarget() {
    return this.target;
  }

  public set_isHyperLinkModeEnabled(enabled) {
    this.tagView.set_isHyperLinkModeEnabled(enabled);
  }

  /*private saveImage(insert, param){
        this.parent.saveImages([this.getImage()], insert, param);
    }*/

  public editTagElement(tagElement) {
    //this.hideImageAdd();
    //this.imageView.hide();
    this.tagView.setIsPartOfGroup(false);
    this.tagView.setGroupExists(false);
    this.tagView.setTagElement(tagElement);
    this.getTemplateViewModel().tagElement(tagElement);
    this.tagView.show();
  }

  public setTagResults(tagResults) {
    if (this.getTemplateViewModel().tagPagination.pageNumber() == 1) {
      this.getTemplateViewModel().tagResults([]);
    }
    if (tagResults.length > 0) {
      let tags = this.getTemplateViewModel().tagResults().concat(tagResults);
      this.getTemplateViewModel().tagResults(tags);

      this.tagNextpageRequested = false;
      if (!this.tagLoadEnable) {
        this.enableTagWaypoint();
      }
    }
  }

  public getSelectedTags() {
    return this.getTemplateViewModel().selectedTags();
  }

  public enableTagWaypoint() {
    var div = document.getElementById("tag-results-list");
    let huit_neuf_this = this;

    var locked = false;
    var lastCall = 0;

    if (div) {
      div!.addEventListener("scroll", function (event) {
        if (locked) return;

        if (lastCall) clearTimeout(lastCall);
        lastCall = setTimeout(() => {
          if (huit_neuf_this) {
            huit_neuf_this.runOnScroll(
              event,
              lastCall,
              locked,
              huit_neuf_this,
              div
            );
          }
        }, 200);
        if (
          document.body.classList.contains("is-fixed") &&
          div.scrollTop != 0 &&
          div.scrollTop + div.clientHeight >= div.scrollHeight - 100 &&
          !huit_neuf_this.tagNextpageRequested
        ) {
          if (
            huit_neuf_this.getTemplateViewModel().tagPagination.pageNumber() <
            huit_neuf_this.getTemplateViewModel().tagPagination.pageMax()
          ) {
            huit_neuf_this
              .getTemplateViewModel()
              .tagPagination.pageNumber(
                huit_neuf_this
                  .getTemplateViewModel()
                  .tagPagination.pageNumber() + 1
              );
            huit_neuf_this.caller.getTagData();
            huit_neuf_this.tagNextpageRequested = true;
          }
        }

        locked = false;
      });
      this.tagLoadEnable = true;
    }
  }

  private runOnScroll(event, lastCall, locked, huit_neuf_this, div) {
    if (locked) return;

    if (lastCall) clearTimeout(lastCall);
    lastCall = setTimeout(() => {
      if (huit_neuf_this) {
        huit_neuf_this.runOnScroll(event, lastCall, locked, huit_neuf_this);
      }
    }, 200);

    locked = false;
  }

  public show() {
    if (!document.body.classList.contains("is-fixed")) {
      document.body.classList.add("is-fixed");
    }
    //this.getTagData();
    this.getTemplateViewModel().isShown(true);
    this.clearSelectedTags();
    //this.tagEdit.show();
  }

  protected clearSelectedTags() {
    this.getTemplateViewModel().selectedTags([]);
  }

  public hide() {
    document.body.classList.remove("is-fixed");
    this.getTemplateViewModel().isShown(false);
  }

  public setPermissions(permissions) {
    this.getTemplateViewModel().permissions(permissions);
    this.tagView.setPermissions(permissions);
    this.tagEdit.setPermissions(permissions);
  }

  public showLoading() {
    let list = document.getElementById("tag-picker-list");
    list!.classList.add("loading");
  }

  public hideLoading() {
    let list = document.getElementById("tag-picker-list");
    list!.classList.remove("loading");
  }

  public showViewLoading() {
    this.tagView.showLoading();
  }

  public showEditLoading() {
    this.tagEdit.showLoading();
  }

  public hideViewLoading() {
    this.tagView.hideLoading();
  }

  public hideEditLoading() {
    this.tagEdit.hideLoading();
  }

  public setTag(tag) {
    this.tagView.setTag(this.initTag(tag), true);
  }

  public setTagAfterSave(tag) {
    this.tagView.setTag(this.initTag(tag), false);
    this.clearProsAndCons();
    this.tagView.show();
  }

  public setTagAfterAddNew(tag) {
    this.tagEdit.show();
    this.tagEdit.setTag(this.initTag(tag));
    this.tagEdit.setupUseTagDefaults(tag);
  }

  public selectTag(tag, selectCommon = false) {
    let selectedTags = this.getTemplateViewModel().selectedTags();
    let alreadySelected = selectedTags.find((i) => i.id === tag.id);
    if (!alreadySelected) {
      let tagToSelect = this.initTag(tag);

      if (selectCommon) {
        this.selectCommonSpecs(tagToSelect);
      }
      selectedTags.push(tagToSelect);
    }

    this.setSelectedTags(selectedTags);
    this.tagEdit.setupUseTagDefaults(tag);
  }

  public selectAllCommonSpecs(selectedTags) {
    for (let tag of selectedTags) {
      this.selectCommonSpecs(tag);
    }
  }

  public selectCommonSpecs(tag) {
    let commonSpecs = this.getTemplateViewModel().commonSpecs();
    let selectedCommonSpecs = commonSpecs.filter((s) => s.selected);
    for (let spec of tag.specs) {
      if (
        spec.value != null &&
        spec.value != "" &&
        selectedCommonSpecs.findIndex((s) => s.fieldId == spec.fieldId) != -1
      ) {
        spec.selected = true;
      } else {
        spec.selected = false;
      }
    }
  }

  public editTagSource(tag) {
    this.caller.setTagEditLock(tag);
  }

  public initializeCkEditors() {
    this.tagView.initTagDescriptionOverrideEditor();
    this.tagEdit.initTagDescriptionEditor();
  }

  public setTagImageOverride(image) {
    this.tagView.setTagImageOverride(image);
  }

  public setTagIconOverride(image) {
    this.tagView.setTagIconOverride(image);
  }

  public setTagImage(image) {
    this.tagEdit.setTagImage(image);
  }

  public setTagIconImage(image) {
    this.tagEdit.setTagIconImage(image);
  }

  public setTagBannerImage(image) {
    this.tagEdit.setTagBannerImage(image);
  }

  public setTagImageBadge(image) {
    this.tagView.setTagImageBadge(image);
  }

  public setTagTypeOptions(tagTypes) {

    this.filterTagType.setOptions(tagTypes);
  }

  public setDatasetFilter(datasets) {

    this.getTemplateViewModel().filterDataset.datasets(datasets);
  }

  public setEditTagTypeOptions(tagTypes) {
    this.tagEdit.setEditTagTypeOptions(tagTypes);
  }

  public setTagViewAffiliateFilterOptions(affiliates) {
    this.tagView.setAffiliateFilterOptions(affiliates);
  }

  public setTagEditLocaleFilterOptions(locales) {
    this.tagEdit.setEditTagLocaleOptions(locales);
  }

  public getTagEditLocales() {
    return this.tagEdit.getEditTagLocales();
  }

  public updateTagEditAutomaticPricingOptions() {
    this.updateAutomaticPricingOptions(this.tagEdit);
  }

  public updateTagViewAutomaticPricingOptions() {
    this.updateAutomaticPricingOptions(this.tagView);
  }

  public clearTagEditAutomaticPricingOptions() {
    this.tagEdit.clearAutomaticPricingOptions();
  }

  public clearTagViewAutomaticPricingOptions() {
    this.tagView.clearAutomaticPricingOptions();
  }

  public setTagViewBadgeOptions(badgeOptions) {
    this.tagView.setBadgeOptions(badgeOptions);
  }

  public onAddTagTypeFilter() {
    let selectedTagTypes = this.getTemplateViewModel().selectedTagTypes();
    let newTagType = this.filterTagType.getOptionObj();
    selectedTagTypes.push(newTagType);
    this.getTemplateViewModel().selectedTagTypes(selectedTagTypes);
    this.resetPagination();
    this.getTagData();
    this.filterTagType.clearInput();
  }
  public setTagEditAffiliateFilterOptions(affiliates) {

    this.tagEdit.setAffiliateFilterOptions(affiliates);
  }

  public onEditTagTypeFilter() {
    this.tagEdit.onEditTagTypeFilter();
  }

  protected updateAutomaticPricingOptions(tag) {
    let partner = tag.filterAffiliates.getOptionObj();
    let isAutoPricingChecked = tag
      .getTemplateViewModel()
      .affiliateAutomaticPricing();
    let isAutoPricingCheckedAvailable = tag
      .getTemplateViewModel()
      .affiliateAutomaticPricingAvailable();

    let showAutoPricing =
      partner.hasPricingSources === true ||
      isAutoPricingCheckedAvailable ||
      isAutoPricingChecked;
    tag
      .getTemplateViewModel()
      .affiliateAutomaticPricingAvailable(showAutoPricing);

    let checkAutoPricing =
      partner.hasPricingSources === true || isAutoPricingChecked;
    tag.getTemplateViewModel().affiliateAutomaticPricing(checkAutoPricing);
  }

  protected onClickDeleteSelectedTagType(data) {
    let selectedTagTypes = this.getTemplateViewModel().selectedTagTypes();

    selectedTagTypes = selectedTagTypes.filter((i) => i.id != data.id);
    this.getTemplateViewModel().selectedTagTypes(selectedTagTypes);
    this.getTagData();
  }

  protected onClickDeleteSelectedTag(tag) {
    this.deselectTag(tag);
    this.deselectTagFromResults(tag);
    //this.getTagData();
  }

  protected deselectTag(tag) {
    let selectedTags = this.getTemplateViewModel().selectedTags();
    selectedTags = selectedTags.filter((s) => s.id != tag.id);
    this.setSelectedTags(selectedTags);
  }

  protected deselectTagFromResults(tag) {
    let tagResults = this.getTemplateViewModel().tagResults();
    let resultTags = tagResults.filter((i) => i.id === tag.id);
    for (let result of resultTags) {
      result.selected = false;
    }
    this.getTemplateViewModel().tagResults([]);
    this.getTemplateViewModel().tagResults(tagResults);
  }

  protected onClickCancelCommonSpecs() {
    //revert to the copy, to preserve original values
    let commonSpecsCopy = this.getTemplateViewModel().commonSpecsCopy();

    this.getTemplateViewModel().commonSpecs([]);
    this.getTemplateViewModel().commonSpecs(
      JSON.parse(JSON.stringify(commonSpecsCopy))
    );
    this.getTemplateViewModel().isCommonSpecsShown(false);
  }

  protected onClickCloseInsertError() {
    this.getTemplateViewModel().isTagGroupError(false);
    this.getTemplateViewModel().isInsertErrorShown(false);
    this.getTemplateViewModel().isInsertErrorForNameShown(false);
    this.getTemplateViewModel().isInsertErrorForBadgeImageShown(false);
  }

  protected onClickApplyCommonSpecs() {
    //here we need to make sure all selected specs follow this convention
    this.refreshCommonSpecs();
    let selectedTags = this.getTemplateViewModel().selectedTags();
    this.selectAllCommonSpecs(selectedTags);
    this.getTemplateViewModel().selectedTags([]);
    this.getTemplateViewModel().selectedTags(selectedTags);
    this.getTemplateViewModel().isCommonSpecsShown(false);
  }

  protected refreshCommonSpecs() {
    let commonSpecs = this.getTemplateViewModel().commonSpecs();
    this.getTemplateViewModel().commonSpecs([]);
    this.getTemplateViewModel().commonSpecs(commonSpecs);
  }

  protected onClickSelectAllCommonSpecs() {
    let commonSpecs = this.getTemplateViewModel().commonSpecs();
    for (let spec of commonSpecs) {
      spec.selected = true;
    }
    this.getTemplateViewModel().commonSpecs([]);
    this.getTemplateViewModel().commonSpecs(commonSpecs);
  }

  protected onClickDeSelectAllCommonSpecs() {
    let commonSpecs = this.getTemplateViewModel().commonSpecs();
    for (let spec of commonSpecs) {
      spec.selected = false;
    }
    this.getTemplateViewModel().commonSpecs([]);
    this.getTemplateViewModel().commonSpecs(commonSpecs);
  }

  protected onClickQuickInsertHyperlink(tag) {
    if (!tag.details) {
      tag.details = {
        color: tag.color,
        vignette: {
          id: tag.idVignette,
        },
      };
    }

    if (!tag.iconImage) {
      tag.iconImage = {
        url: tag.iconImageUrl,
      };
    }

    this.insertTagHyperlink(null, { name: tag.name, tag: tag }, true);
  }

  protected getTagData() {
    this.caller.getTagData();
  }

  public setTagsPagination(totalPage, currentPage) {
    this.getTemplateViewModel().tagPagination.pageMax(totalPage);
    this.getTemplateViewModel().tagPagination.pageNumber(currentPage);
  }

  public getTagElementInsertedFieldsInOrder(element) {
    let idTag = element.getAttribute("data-id");
    let fieldElements: any[] = [];
    let specsElement = element.querySelector(
      `[data-field="${TAG_DATA_FIELDS.SPECS}"]`
    );
    if (specsElement) {
      let fieldElementHtmlTags = specsElement.querySelectorAll("dt");
      if (fieldElementHtmlTags.length > 0) {
        for (let fieldElementHtmlTag of fieldElementHtmlTags) {
          fieldElements.push(fieldElementHtmlTag.innerText.toLowerCase());
        }
      }
    }

    return { id: idTag, insertedFields: fieldElements };
  }
  public setGroupings(grouping) {
    this.getTemplateViewModel().groupings(grouping);
  }

  public getGroupings() {
    return this.getTemplateViewModel().groupings();
  }

  public initTag(tag: Tag): Tag {
    let element = this.getTemplateViewModel().tagElement();
    let id = tag.id;
    let name = tag.name;
    let type,
      viewType,
      description,
      seoDescription,
      image,
      iconImage,
      bannerImage,
      imageGroup,
      vignette,
      reviewScore,
      embargoScoreIsIncluded = tag.embargoScoreIsIncluded || false;

    let specsWithValues: SpecsValue[] = [];
    let allDefaultSpecs: SpecsValue[] = [];
    let allSpecs: SpecsValue[] = [];
    let affiliateLinks = [];
    let tempAffiliateLinks = [];
    let isSelectable = false;
    let brandOwner: emaki_brand | null = null;

    if (tag.defaults && tag.defaults.vignette) {
      vignette = tag.defaults.vignette;
    }

    if (tag.details != null) {
      description = tag.details.description
        ? tag.details.description
        : tag.defaults.description;
      seoDescription = tag.details.shortDescription
        ? tag.details.shortDescription
        : tag.defaults.shortDescription;
      reviewScore = tag.details.reviewScore;
      isSelectable = tag.details.isSelectable;
      // reviewScoreIsUnderEmbargo = tag.details.reviewScoreIsUnderEmbargo;
      // reviewScoreEmbargoEndDate = tag.details.reviewScoreEmbargoEndDate;

      if (tag.details.image != null) {
        image = tag.details.image;
      } else if (tag.defaults.image != null) {
        image = tag.defaults.image;
      }

      if (tag.details.iconImage != null) {
        iconImage = tag.details.iconImage;
      } else if (tag.defaults.iconImage != null) {
        iconImage = tag.defaults.iconImage;
      }

      if (tag.details.bannerImage != null) {
        bannerImage = tag.details.bannerImage;
      } else if (tag.defaults.bannerImage != null) {
        bannerImage = tag.defaults.bannerImage;
      }

      if (tag.details.imageGroup != null) {
        // @TODO why am I not stringifying this
        imageGroup = JSON.parse(tag.details.imageGroup);

        // @TODO this should be happening before it gets here
        if (Array.isArray(imageGroup) && imageGroup.length > 0) {
          imageGroup = imageGroup[0];
        }
      } else if (tag.defaults.imageGroup != null) {
        imageGroup = JSON.parse(tag.defaults.imageGroup);

        // @TODO this should be happening before it gets here
        if (Array.isArray(imageGroup) && imageGroup.length > 0) {
          imageGroup = imageGroup[0];
        }
      }

      if (tag.details.affiliateLinks != null) {
        affiliateLinks = JSON.parse(JSON.stringify(tag.details.affiliateLinks));
      } else if (tag.defaults.affiliateLinks != null) {
        affiliateLinks = JSON.parse(
          JSON.stringify(tag.defaults.affiliateLinks)
        );
      }
      if (tag.details.vignette !== null) {
        vignette = tag.details.vignette;
      }
    } else {
      description = tag.defaults.description;
      seoDescription = tag.defaults.shortDescription;
      if (tag.defaults.image != null) {
        image = tag.defaults.image;
      }
      if (tag.defaults.iconImage != null) {
        iconImage = tag.defaults.iconImage;
      }
      if (tag.defaults.bannerImage != null) {
        bannerImage = tag.defaults.bannerImage;
      }
      if (tag.defaults.imageGroup != null) {
        imageGroup = JSON.parse(tag.defaults.imageGroup);

        // @TODO this should be happening before it gets here
        if (Array.isArray(imageGroup) && imageGroup.length > 0) {
          imageGroup = imageGroup[0];
        }
      }
    }

    if (tag.type != null) {
      type = tag.type;
      if (typeof tag.type !== "string" && tag.type.brandOwner != undefined) {
        brandOwner = tag.type.brandOwner;
      }
    }

    if (tag.viewType != null) {
      viewType = tag.viewType;
    }

    if (tag.specsValues != null || tag.specDefaults != null) {
      allSpecs = this.foldDefaultsIntoSpecs(tag);
    }

    specsWithValues = allSpecs.filter(
      (s) =>
        (s.value != null && s.value.length > 0) ||
        (s.isDefault && s.defaultValue != null && s.defaultValue != "")
    );

    let specsHavingValue: SpecsValue[] = this.reorderTagSpecifications(
      id,
      specsWithValues
    );

    if (specsHavingValue.length == 0) {
      specsHavingValue = specsWithValues;
    }
    return {
      id: id,
      name: name,
      badge: null,
      badgeImage: null,
      subtitle: null,
      pros: tag.pros,
      cons: tag.cons,
      type: type,
      viewType: viewType,
      description: description,
      descriptionOverride: null,
      seoDescription: seoDescription,
      seoDescriptionOverride: null,
      reviewScore: reviewScore,
      reviewScoreOverride: null,
      embargoScoreIsIncluded: embargoScoreIsIncluded,
      image: image,
      iconImage: iconImage,
      bannerImage: bannerImage,
      imageGroup: imageGroup,
      imageOverride: null,
      specs: specsHavingValue,
      allSpecs: allSpecs,
      affiliateLinks: affiliateLinks,
      tempAffiliateLinks: tempAffiliateLinks,
      includeStreamRentBuyLinks: tag.includeStreamRentBuyLinks,
      isSelectable: isSelectable,
      showImageGroup: "true",
      isBrandOwnerUrlHubPage: tag.isBrandOwnerUrlHubPage,
      details: tag.details,
      defaults: tag.defaults,
      idReference: tag.idReference,
      referenceDescription: tag.referenceDescription,
      providerRelationships: tag.providerRelationships
        ? tag.providerRelationships
        : [],
      includeCommunityRating: tag.includeCommunityRating,
      communityRating: tag.communityRating,
    };
  }

  protected foldDefaultsIntoSpecs(tag) {
    const allSpecs = JSON.parse(JSON.stringify(tag.specsValues));
    const allDefaultSpecs = JSON.parse(JSON.stringify(tag.specDefaults));
    const processSpecValue = (spec: any, specValue): string => {
      if (spec.dataType == "tag" || spec.dataType == "tags") {
        if (specValue != null && specValue.length > 0) {
          specValue = specValue
            .map(function (tag) {
              const tagType = tag.formattedTagTypeAndDataset;
              return tag.name + (tagType ? ` ${tagType}` : "");
            })
            .join(", ");
        }
      } else if (spec.dataType == "date" && specValue != null) {
        //remove the 00 from date
        specValue = specValue.replaceAll("-00", "");
      }

      return specValue;
    };

    //specs = specs.filter(s => s.value != null && s.value.length > 0);

    return allSpecs.map((spec) => {
      let specValue = spec.value;
      spec.originalValue = spec.value;

      const specDefault = allDefaultSpecs.filter(
        (defaultSpec) => spec.fieldId === defaultSpec.fieldId
      );
      if (specDefault && specDefault[0]) {
        const specDefaultValue = specDefault[0].value;
        spec.originalDefaultValue = specDefaultValue;
        spec.defaultValue = processSpecValue(specDefault[0], specDefaultValue);
      }

      spec.disabled =
        spec.dataType !== "text" &&
        spec.dataType !== "currency" &&
        spec.dataType !== "number" &&
        spec.dataType !== "rating";

      spec.value = processSpecValue(spec, specValue);

      return spec;
    });
  }

  public reorderTagSpecifications(id, specifications: any[]) {
    let insertedTagSpecs = this.getInsertedFieldsByTag(id);
    let specsHavingValue: SpecsValue[] = [];

    if (insertedTagSpecs && insertedTagSpecs.insertedFields.length > 0) {
      for (let insertedField of insertedTagSpecs.insertedFields) {
        for (let specWithValue of specifications) {
          if (
            insertedField
              .toLowerCase()
              .localeCompare(specWithValue.label.toLowerCase()) == 0
          ) {
            specsHavingValue.push(specWithValue);
          }
        }
      }

      let nonSelectedFields = specifications.filter(
        (swv) =>
          insertedTagSpecs!.insertedFields.indexOf(swv.label.toLowerCase()) ===
          -1
      );
      for (let nonSelectedField of nonSelectedFields) {
        specsHavingValue.push(nonSelectedField);
      }
      specsHavingValue.concat(nonSelectedFields);
    }

    return specsHavingValue;
  }

  public clearProsAndCons() {
    this.tagEdit.getTemplateViewModel().tempTagItemPros([]);
    this.tagEdit.getTemplateViewModel().tempTagItemCons([]);
  }

  public getBooleanAttribute(element, attributeName) {
    let attributeValue = element.getAttribute(attributeName);
    return (
      attributeValue === "true" ||
      attributeValue === true ||
      attributeValue === "1"
    );
  }

  public setTagGroupTagElements(elements) {
    this.getTemplateViewModel().tagGroupTagElements(elements);
  }

  public getTagGroupTagElements() {
    return this.getTemplateViewModel().tagGroupTagElements();
  }

  public getBrandOwner(): emaki_brand | null {
    return this.getTemplateViewModel().brandOwner();
  }

  public getInsertedFieldsByTag(
    tagId
  ): { id: any; insertedFields: any[] } | null {
    let insertedTagsListSpecs = this.getTagGroupTagElements();
    let filteredTagElement: { id: any; insertedFields: any[] } | null = null;

    if (
      !Array.isArray(insertedTagsListSpecs) ||
      !(insertedTagsListSpecs.length > 0)
    ) {
      return filteredTagElement; // no valid data
    }

    let insertedTagSpecsFiltered = insertedTagsListSpecs.filter(
      (it) => it.id == tagId
    );

    if (insertedTagSpecsFiltered.length > 0) {
      // the tag is part of a group

      filteredTagElement = insertedTagSpecsFiltered[0];
    } else {
      // it's a single tag

      let tagElement = this.getTemplateViewModel().tagElement();
      if (tagElement != null) {
        filteredTagElement =
          this.getTagElementInsertedFieldsInOrder(tagElement);
      }
    }

    return filteredTagElement;
  }
  public setTagTypeDropdown(tagTypes) {
    this.getTemplateViewModel().filterDataset.dataTypeOptions(tagTypes);
  }

  public deleteAllSelectedTagType() {
    this.getTemplateViewModel().selectedTagTypes([]);
    this.getTagData();
  }
}



// WEBPACK FOOTER //
// ./js/components/templates/tagPicker_template.ts